import { useContext, useEffect, useState } from 'react'
import useAxiosRequests from '../hooks/useAxiosRequest'
import ExternalRoutes from '../config/ExternalRoutes'
import AuthContext from '../context/AuthContext'
import MainHeader from '../components/MainHeader'
import { Subscription } from '../components/Subscription'
import { daysRemaining } from '../utils/FormatDate'

function PayementList() {
  const [payments, setPayments] = useState([])
  const { sendRequest } = useAxiosRequests()
  const { userInfo } = useContext(AuthContext)


  const fecthData = async () => {
    try {
      const response = await sendRequest({
        method: 'GET',
        url: ExternalRoutes.subscription.list_by_user + userInfo?.id
      })
      if (response) {
        setPayments(response.member)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    fecthData()
  }, [])

  return (
    <>
      <MainHeader />
      <section>
        <div style={{ padding: "15px", display: "grid", gap: 8 }}>
          {payments.length > 0 ? (
            <>
              {payments.map((data, index) => {
                const usrSubDateEnd = daysRemaining(data?.usrSubDateEnd);
                return (
                  <Subscription
                    key={data?._id || index}
                    data={data?.conSubscriptionId?.subPrice}
                    dateExpired={usrSubDateEnd}
                    isProfile={false}
                  />
                );
              })}
            </>
          ) : (
            <div style={{ textAlign: "center", color: "#888", marginTop: "150px" }}>
              Vous n’êtes pas encore abonné.
            </div>
          )}
        </div>
      </section>
    </>
  )
}

export default PayementList
